import React from 'react'
import Layout from '../components/Layout'
import { Link } from 'react-router-dom'

export default function CreateCollectionOptions() {
    return (
        <Layout>
            <div class="no-bottom no-top" id="content">
                <section aria-label="section">
                    <div class="container">
                        <div class="row wow fadeIn ">
                        <p className='text-center'>Choose "Single" if you want your collectible to be one of a kind or "Multiple" if you want to sell one collectible times</p>
                            <div class="col-12 d-flex justify-content-center">
                                
                                <Link to="/create-collection/erc721" class="opt-create">
                                    <img src="/nft/images/misc/coll-single.png" alt="" />
                                    <h3>ERC721</h3>
                                </Link>
                                <Link to="/create-collection/erc1155" class="opt-create">
                                    <img src="/nft/images/misc/coll-multiple.png" alt="" />
                                        <h3>ERC1155</h3>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    )
}
